// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trend-sidebar-module__sidebar--OFGno{width:240px;flex-basis:240px;flex-grow:0;flex-shrink:0;display:none}@media screen and (min-width:1152px){.trend-sidebar-module__sidebar--OFGno{display:block}}", ""]);
// Exports
exports.locals = {
	"sidebar": "trend-sidebar-module__sidebar--OFGno"
};
module.exports = exports;
